import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class HttpHeadersService {

  constructor() { }
  httpOptions: any;
  getCommonHttpHeaders() {
    var token_key;

    token_key = localStorage.getItem('token_key');       
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Authorization': 'Bearer ' + token_key
      })
    };
    return this.httpOptions
  }

  getLoginHttpHeaders() {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Content-Type',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'portal': 'admin'
      })
    };
    return this.httpOptions
  }

}
